/**
 * Sep 30 F3: finalizar el cierre del día actual pide la contraseña de la sesión.
 * El backend valida lo mismo (hoy en hora Argentina); días anteriores no la piden.
 * Run: docker exec -w /app abs-dev-frontend-1 npx tsx --test src/lib/cierreFinalizarPassword.test.ts
 */
import { toDateOnlyString } from "@/lib/utils";

export function cierreFinalizarNecesitaPassword(fecha: unknown, todayYmd: string): boolean {
  const ymd = typeof fecha === "string" ? toDateOnlyString(fecha) || "" : "";
  return Boolean(ymd) && ymd === todayYmd;
}

export function cierreFinalizarBody(password?: string): Record<string, unknown> {
  const pwd = (password || "").trim();
  return pwd ? { password: pwd } : {};
}
